module.exports = __webpack_public_path__ + "static/media/connector-logo-keap.bb9ff4f5.png";